/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import CheckBoxGroup from '../../components/filterTypes/checkbox/checkboxGroup';
import MultiselectBox from '../../components/filterTypes/multiselectbox/MultiselectBox';
import { OptionsType, OptionType } from '../../components/filterTypes/multiselectbox/types';
import { useTranslation } from '../../hooks/useTranslation';
import { filterLabels, filterTrackings, filterValues } from './FilterFunctions';
import { Chip, ChipContainer, ChipType } from '@festo-ui/react';
import { InfoButtonPopup } from 'festo-react-ui-kit';
import { econdaClickEvent } from '../../Econda';
import './FacetWrapper.scss';

interface FacetWrapperProps {
  econdaName: string;
  filterKey: string;
  options: OptionsType;
  label: string;
  onChange: (values: any) => void;
  onInputChange: (inputValue: string, { action }: any) => void;
  isCombobox: boolean;
  type: string;
  selected: any;
  placeholder?: string;
  infoButtonDescription: string;
  tableRef: React.RefObject<HTMLDivElement>;
}

function FacetWrapper(props: FacetWrapperProps): JSX.Element | null {
  const t = useTranslation();
  const infoButtonConditionallyResistanceType = 'infoButtonConditionallyResistanceType';

  const handleChipClick = (e: React.MouseEvent<HTMLElement, MouseEvent>, option: OptionType, selected: boolean) => {
    e.stopPropagation();
    handleOptionChange(option);
    econdaClickEvent(
      `material categories`,
      'filters',
      'tool tip',
      `${t(option.translationKey)} | ${(!selected && 'select') || 'unselect'}`,
    );
  };

  const handleOptionChange = (option: OptionType) => {
    props.onChange(option);
  };
  switch (props.type) {
    case 'checkbox':
      return (
        <>
          <CheckBoxGroup
            options={props.options}
            label={props.label}
            onChange={props.onChange}
            selected={props.selected}
          />
          <div className="pt-2 radio">*{t(infoButtonConditionallyResistanceType)}</div>
        </>
      );
    case 'multiSelectBox':
      return (
        <MultiselectBox
          filterKey={props.filterKey}
          econdaName={props.econdaName}
          options={props.options}
          label={props.label}
          getOptionLabel={filterLabels[props.filterKey]}
          getOptionValue={filterValues[props.filterKey]}
          getOptionTracking={filterTrackings[props.filterKey]}
          onInputChange={props.onInputChange}
          isCombobox={props.isCombobox}
          onChange={props.onChange}
          values={props.selected}
          placeholder={props.placeholder}
          infoButtonDescription={props.infoButtonDescription}
          applyText={t('applyText')}
          cancelText={t('cancelText')}
          tableRef={props.tableRef}
        />
      );
    case 'multiSelectChip':
      return (
        <div className="multiselectchip-container">
          <label className="radio-label pb-3">{props.label}</label>
          <span
            onClick={() =>
              econdaClickEvent(`${props.econdaName} filter`, 'filters', 'tool tip', `${props.econdaName} tool tip`)
            }
          >
            <InfoButtonPopup>
              <p>{props.infoButtonDescription}</p>
            </InfoButtonPopup>
          </span>
          <ChipContainer>
            {props.options.length > 0 &&
              props.options.map((option) => {
                const selected =
                  props.selected.findIndex((selectedOption: any) => selectedOption.id === option.id) !== -1;
                return (
                  <button className="button-chip" key={option.id} onClick={(e) => handleChipClick(e, option, selected)}>
                    <Chip selected={selected} type={ChipType.Choice}>
                      {t(option.translationKey)}
                    </Chip>
                  </button>
                );
              })}
          </ChipContainer>
        </div>
      );
    default:
      return null;
  }
}

export default FacetWrapper;
